export const CREATE_CARDS = "CREATE_CARDS";
export const SET_STARTED = "SET_STARTED";
export const CREATE_STOCK_AND_TABLEAU = "CREATE_STOCK_AND_TABLEAU";
export const SET_SELECTED = "SET_SELECTED";
export const CLEAR_SELECTED = "CLEAR_SELECTED";
export const MOVE_CARDS = "MOVE_CARDS";
export const ADD_CARDS = "ADD_CARDS";
export const RESET = "RESET";
export const SET_TIME = "SET_TIME";
export const SET_ALERT = "SET_ALERT";
export const CLEAR_ALERT = "CLEAR_ALERT";
export const SET_ENDED = "SET_ENDED";
